export const moduleName = 'myCommunity'
